import {client} from '@core/GraphQLProvider';
import {GetAllProductInstructions, GetDistributorsForCountry, GetTamsByZipCode} from './query.graphql';

const ResourcesService = {
    async getDistributorsForCountry ( countryId ) {
        const resp = await client.query( {
            query: GetDistributorsForCountry,
            variables: {countryId}
        } );

        return resp.data.distributorsForCountry;
    },

    async getAllProductInstructions () {
        const resp = await client.query( {
            query: GetAllProductInstructions
        } );

        return resp.data.allIfus;
    },

    async getTamsByZipCode ( zipCode ) {
        if ( !zipCode ) {
            throw new Error( `"zipCode" is a required parameter, received "${zipCode}" instead` );
        }
        const resp = await client.query( {
            query: GetTamsByZipCode,
            variables: {zipCode}
        } );

        return resp.data.tamByZipCode;
    }

};

export default ResourcesService;
